import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { PaginationInfoType } from 'redux/payroll/OffCyclePayrun/types'
import * as actions from './actions'

export type ScoreDetails = {
  excellent: number
  very_good: number
  average: number
  below_Average: number
  very_poor: number
}

type Assessors = {
  submitted_ids: number[]
  pending_ids: number[]
}

export type ScoreData = {
  rank: number
  assessors_ids: number[]
}

export type AssessmentSkills = {
  name: string
  score: number
  score_data: ScoreData[]
  stage_names: string[]
}

export type Feedbacks = {
  assessor_id: number
  text: string
}

export type SubmittedAssessments = {
  id: number
  job_id: number
  title: string
  last_update: string
  total_score: number
  score_details: ScoreDetails
  assessors: Assessors
  assessment_skills: AssessmentSkills[]
  feedbacks: Feedbacks[]
}

export type Assessment = {
  assessment_skill_id: number
  rating: number
}

export type CreateSubmittedAssessmentRequest = {
  assessment_submissions: {
    assessment_card_id: number
    candidate_id: number
    assessments: Assessment[]
    feedback?: {
      text: string
    }
  }
}

type InitialStateType = {
  submitted_assessments: SubmittedAssessments[]
  fetching: boolean
  pagination: PaginationInfoType
}

const initialState: InitialStateType = {
  submitted_assessments: [],
  fetching: true,
  pagination: {
    current_page: 1,
    per_page: 1,
    next_page: 2,
    previous_page: 1,
    total_pages: 0,
    total_entries: 0,
  },
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.CREATE_SUBMITTED_ASSESSMENT_PENDING:
    case actions.GET_CANDIDATE_ASSESSMENT_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.CREATE_SUBMITTED_ASSESSMENT_FULFILLED: {
      Toastr.success(action.payload.data.data.message)
      return {
        ...state,
        fetching: false,
      }
    }

    case actions.GET_CANDIDATE_ASSESSMENT_FULFILLED: {
      return {
        ...state,
        submitted_assessments: [
          ...state.submitted_assessments,
          ...action?.payload.data.data.submitted_assessments,
        ],
        fetching: false,
        pagination: action?.payload?.data?.data?.pagination,
      }
    }

    case actions.CREATE_SUBMITTED_ASSESSMENT_REJECTED:
    case actions.GET_CANDIDATE_ASSESSMENT_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    case actions.CLEAR_GET_CANDIDATE_ASSESSMENT: {
      return {
        ...state,
        submitted_assessments: [],
      }
    }

    default:
      return state
  }
}
